// import script accordingly
// import "./themes/header/_header";
// import "./themes/header/_footer";

import './themes/loop/_loop';
import './themes/lightbox/_lightbox';
